// @flow
import React from 'react'
import formatters from 'lib/formatters'
import styles from './styles.css'
import IconSwitch from 'components/IconSwitch/IconSwitch'

type Props = {
  subaccount?: Object,
  accountSummary?: Object,
  accountNumber: string,
}

const AccountInfo = ({ subaccount, accountSummary }: Props) => {
  if (!subaccount) {
    return <div>Loading subaccount data...</div>
  }

  const account = subaccount.account || {}

  const status = subaccount.status === null ? 'pending' : subaccount.status || 'Active'

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return styles.statusActive
      case 'closed':
        return styles.statusClosed
      case 'pending':
        return styles.statusPending
      default:
        return styles.statusActive
    }
  }

  return (
    <div>
      <div className={styles.dashboard}>
        <div className={styles.header}>
          <div className={styles.idBadge}>
            <span>{accountSummary.number}</span>
          </div>
          <h2 className={styles.accountName}>{accountSummary.productDescription}</h2>
        </div>
        <div className={styles.balanceSection}>
          <div className={styles.mainBalance}>
            <div className={styles.balanceLabel}>Main Account Balance</div>
            <div className={styles.balanceAmount}>{formatters.money(accountSummary.balance)}</div>
          </div>
          <div className={styles.subBalance}>
            <div className={styles.balanceLabel}>Subaccounts Total Balance</div>
            <div className={styles.balanceAmount}>{formatters.money(accountSummary.subaccountBalance)}</div>
          </div>
        </div>

        <div className={styles.divider}></div>

        <div className={styles.subaccountSection}>
          <div className={styles.combinedSection}>
            <div className={styles.subaccountHeader}>
              <h4 className={styles.subaccountInfo}>SUBACCOUNT INFORMATION</h4>
              <div className={`${styles.status} ${getStatusClass(status)}`}>
                <div className={styles.statusIndicator}></div>
                <span className={styles.statusText}>{formatters.legibleAccountStatus(status) || ''}</span>
              </div>
            </div>

            <div className={styles.subaccountDates}>
              <div>Last update {subaccount?.updated_at ? formatters.lastUpdate(subaccount.updated_at) : 'N/A'}</div>
              <div>Open {subaccount?.created_at ? formatters.date(subaccount.created_at) : 'N/A'}</div>
            </div>
          </div>

          <div className={styles.divider}></div>

          <div className={styles.infoRow}>
            <div className={styles.infoLabel}>Floor</div>
            <div className={styles.infoValue}>{account?.floor ? formatters.money(account.floor) : '$0.00'}</div>
          </div>

          <div className={styles.divider}></div>

          <div className={styles.infoRow}>
            <div className={styles.infoLabel}>Budget</div>
            <div className={styles.infoValue}>{account?.budget !== undefined ? <IconSwitch flag={account.budget} /> : <span>—</span>}</div>
          </div>
          <div className={styles.divider}></div>
        </div>
      </div>
    </div>
  )
}

export default AccountInfo
